import {resolveBackground, resolveBorderColor} from '#core/utils/color-utils.js';
import {isIOS} from '#core/utils/context-utils.js';
import {merge} from '#core/utils/config-utils.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import STAKE_INPUT from './stake-input.palette-schema.yaml';

registerTileSchema(STAKE_INPUT);

export function generateStakeInput(PALETTE) {
    const INPUT = {
        style: {
            base: {
                backgroundColor: 'transparent',
                ...resolveBackground(PALETTE.STAKE_INPUT_BG),
                ...(isIOS() ? {_mobile_fontSize: 16} : {}), // increased font size to avoid automatic zoom-in on iOS devices
                borderColor: PALETTE.STAKE_INPUT_BORDER_COLOR,
                minHeight: 40,
                padding: '0 8px',
                borderWidth: 1,
                borderRadius: PALETTE.STAKE_INPUT_BORDER_RADIUS,
                borderStyle: 'solid',
                outline: 'none',
                ...PALETTE.STAKE_INPUT_TEXT,
            },

            focus: {
                ...resolveBorderColor(PALETTE.STAKE_INPUT_FOCUSED_BORDER_COLOR),
            },
            error: {
                ...PALETTE.STAKE_INPUT_ERROR_TEXT,
                borderColor: PALETTE.STAKE_INPUT_ERROR_BORDER_COLOR,
            },
            disabled: {
                ...resolveBackground(PALETTE.STAKE_INPUT_DISABLED_BG),
                borderWidth: 1,
                borderColor: PALETTE.STAKE_INPUT_DISABLED_BORDER_COLOR,
                borderRadius: PALETTE.STAKE_INPUT_BORDER_RADIUS,
                ...PALETTE.STAKE_INPUT_DISABLED_TEXT,
            },
        },
    };

    return {
        textInput: INPUT,
        customTextInput: merge(INPUT, {
            style: {
                cursor: {
                    backgroundColor: PALETTE.STAKE_INPUT_TEXT.color,
                },
            },
        }),
    };
}
